import React, { Component } from 'react'
import {gaEvent} from '../../util/ga'

// components
import Button from '../Button/Button'

// assets
import Strings from '../../assets/strings.json'

class Finish extends Component {
  componentDidMount() {
    gaEvent({
      action: 'Enter step',
      category: 'Branntips form',
      label: 'Bekreftelse'
    })
  }

  render(){
    const {data, sendMe, step} = this.props

    return (
      <div className="finish md:pt-48 pt-12 md:pb-48 pb-32">
        <h1 className="title md:text-4xxl text-xl md:text-left text-center font-bold mb-9">{ step.title }</h1>
        <div className="step-desc md:text-xl1/5 text-lg leading-normal mb-8" dangerouslySetInnerHTML={{__html: (Strings[document.body.dataset.lang].finishText).replace('@', data.name)}} />
        <div className="result-item w-full border-b border-b-grey-lighter mb-8">
          <div className="result-item-inner">
            <h3 className="result-item-title font-semibold text-red text-sm mb-8">{ Strings[document.body.dataset.lang].contactInfo.replace('@', data.name) }</h3>
            <div className={`result-item-content md:text-xl1/5 text-lg mb-5 font-normal`}>
              { data.tel ? <a className="lg:inline-block block lg:mt-0 mt-8 text-black no-underline underline-custom" href={`tel:${data.tel}`}>{data.tel}</a> : Strings[document.body.dataset.lang].noPhone }
              { data.email ? <a className="lg:inline-block block lg:ml-8 lg:mt-0 mt-8 text-black no-underline underline-custom" href={`mailto:${data.email}`}>{data.email}</a> : <span className="md:inline-block block md:ml-8 md:mt-0 mt-8 text-black no-underline">{Strings[document.body.dataset.lang].noEmail}</span> }
            </div> 
          </div>
        </div>
        <div className="result-item w-full overflow-hidden">
          <div className="result-item-inner max-w-sm">
            <h3 className="result-item-title font-semibold text-red text-sm mb-8">{ Strings[document.body.dataset.lang].reference }</h3>
            <div className={`result-item-content text-xl1/5 mb-12 font-normal`}>
              { data.uuid }
            </div>
          </div>
        </div>
        { sendMe ?
        <div className="result-item w-full overflow-hidden">
          <div className="result-item-inner max-w-sm">
            <div className={`result-item-content inline-block text-xl1/5 mb-8 font-normal`}>
              <Button click={() => { window.location.href = document.body.dataset.lang === 'default' ? '/' : '/en' }} color="black" name={Strings[document.body.dataset.lang].backHome} className="mr-auto" />
            </div>
          </div>
        </div> : null}
      </div>
    )
  }  
}

export default Finish
